/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];
class DwmAddresses {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {

        $scope.formIsValid = true;
        $scope.updateFormIsValid = true;

        $scope.address1IsValid = true;
        $scope.address2IsValid = true;
        $scope.postalCodeIsValid = true;
        $scope.cityIsValid = true;

        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};

            if (assets.primaryMember) {

                $scope.addresses = assets.primaryMember.monitoredAccounts.addresses;
                $scope.addresses.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.formIsValid = true;
            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('#address-1').focus();

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.formIsValid = true;
            $scope.address1IsValid = true;
            $scope.address2IsValid = true;
            $scope.postalCodeIsValid = true;
            $scope.cityIsValid = true;

            $scope.newAddress1 = '';
            $scope.newAddress2 = '';
            $scope.newPostalCode = '';
            $scope.newCity = '';

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.address1IsValid = true;
            $scope.address2IsValid = true;
            $scope.postalCodeIsValid = true;
            $scope.cityIsValid = true;

            $scope.addresses.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    const newEntry = { ...entry };
                    $scope.updateEntryPayload = newEntry;

                } else {

                    entry.showUpdateInput = false;

                }

            });

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.updateFormIsValid = true;
            $scope.address1IsValid = true;
            $scope.address2IsValid = true;
            $scope.postalCodeIsValid = true;
            $scope.cityIsValid = true;

            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.addresses.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

        };

        $scope.validateAddress1 = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.address1IsValid =
                    validations.addressStreet1Validator($event.currentTarget.value);

            }

            $scope.newAddress1 = $event.currentTarget.value;

            $scope.formIsValid =
                $scope.address1IsValid &&
                $scope.address2IsValid &&
                $scope.postalCodeIsValid &&
                $scope.cityIsValid;

        };

        $scope.validateAddress2 = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.address2IsValid =
                    validations.addressStreet2Validator($event.currentTarget.value);

            }

            $scope.newAddress2 = $event.currentTarget.value;

            $scope.formIsValid =
                $scope.address1IsValid &&
                $scope.address2IsValid &&
                $scope.postalCodeIsValid &&
                $scope.cityIsValid;

        };

        $scope.validatePostalCode = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.postalCodeIsValid =
                    validations.postalCodeValidator($event.currentTarget.value);

            }

            $scope.newPostalCode = $event.currentTarget.value;

            $scope.formIsValid =
                $scope.address1IsValid &&
                $scope.address2IsValid &&
                $scope.postalCodeIsValid &&
                $scope.cityIsValid;

        };

        $scope.validateCity = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.cityIsValid =
                    validations.cityValidator($event.currentTarget.value);

            }

            $scope.newCity = $event.currentTarget.value;

            $scope.formIsValid =
                $scope.address1IsValid &&
                $scope.address2IsValid &&
                $scope.postalCodeIsValid &&
                $scope.cityIsValid;

        };

        $scope.validateForm = () => {

            if ($scope.newEntrySubmitted) {

                $scope.address1IsValid =
                    validations.addressStreet1Validator($scope.newAddress1);
                $scope.address2IsValid =
                    validations.addressStreet2Validator($scope.newAddress2);
                $scope.postalCodeIsValid =
                    validations.postalCodeValidator($scope.newPostalCode);
                $scope.cityIsValid =
                    validations.cityValidator($scope.newCity);

            }

            $scope.addressExists = $scope.addresses.entries
                .find(address => address.street1 === $scope.newAddress1 &&
                address.street2 === $scope.newAddress2 &&
                address.postalCode === $scope.newPostalCode &&
                address.city === $scope.newCity);

            $scope.formIsValid =
                $scope.address1IsValid &&
                $scope.address2IsValid &&
                $scope.postalCodeIsValid &&
                $scope.cityIsValid &&
                !$scope.addressExists;

        };

        $scope.saveNewEntry = () => {

            $scope.newEntrySubmitted = true;
            $scope.validateForm();

            if ($scope.formIsValid) {

                $scope.saveNewAddressIsLoading = true;

                let payload;
                if ($scope.addresses.entries.length === 0) {

                    payload = {
                        primaryAddress: {
                            street1: $scope.newAddress1,
                            street2: $scope.newAddress2,
                            postalCode: $scope.newPostalCode,
                            city: $scope.newCity,
                            countryCode: 'DE',
                            type: 'CURRENT',
                            isPrimaryAddressEmpty: true,
                        },
                    };

                } else {

                    payload = {
                        addresses: {
                            street1: $scope.newAddress1,
                            street2: $scope.newAddress2,
                            postalCode: $scope.newPostalCode,
                            city: $scope.newCity,
                            countryCode: 'DE',
                        },
                    };

                }


                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newAddress1 = '';
                    $scope.newAddress2 = '';
                    $scope.newPostalCode = '';
                    $scope.newCity = '';

                    $scope.saveNewAddressIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } =
                            membersResponse.data.primaryMember;

                        Mixpanel.setCommonProperty('AIA Asset Address', monitoredAccounts.addresses.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Addresses',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.saveNewAddressIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });

            } else if ($scope.addressExists) {

                Alert.error('cw.dwm.dupliacte_entry_error');

            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                addresses:
                {
                    id: $scope.addresses.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newAddress1 = '';
                $scope.newAddress2 = '';
                $scope.newPostalCode = '';
                $scope.newCity = '';

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Address', monitoredAccounts.addresses.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Addresses',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.entryUpdateValue = ($event, key) => {

            if (key === 'street1') {

                $scope.address1IsValid =
                    validations.addressStreet1Validator($event.currentTarget.value);

            }

            if (key === 'street2') {

                $scope.address2IsValid =
                    validations.addressStreet2Validator($event.currentTarget.value);

            }

            if (key === 'postalCode') {

                $scope.postalCodeIsValid =
                    validations.postalCodeValidator($event.currentTarget.value);

            }

            if (key === 'city') {

                $scope.cityIsValid =
                    validations.cityValidator($event.currentTarget.value);

            }

            $scope.updateEntryPayload[key] = $event.currentTarget.value;

            $scope.updateFormIsValid =
                $scope.address1IsValid &&
                $scope.address2IsValid &&
                $scope.postalCodeIsValid &&
                $scope.cityIsValid;

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $scope.addressExistsUpdate = $scope.addresses.entries
                .find(address => address.street1 === $scope.updateEntryPayload.street1 &&
                address.street2 === $scope.updateEntryPayload.street2 &&
                address.postalCode === $scope.updateEntryPayload.postalCode &&
                address.city === $scope.updateEntryPayload.city);

            if (!$scope.updateFormIsValid || $scope.addressExistsUpdate) {

                if ($scope.addressExistsUpdate) {

                    $scope.saveUpdatedEntryIsLoading = false;
                    Alert.error('cw.dwm.dupliacte_entry_error');

                }

                return;

            }

            let data;

            if ($scope.updateEntryPayload.type === 'CURRENT') {

                data = {
                    primaryAddress: {
                        street1: $scope.updateEntryPayload.street1,
                        street2: $scope.updateEntryPayload.street2,
                        postalCode: $scope.updateEntryPayload.postalCode,
                        city: $scope.updateEntryPayload.city,
                        countryCode: 'DE',
                        stateCode: '',
                        type: $scope.updateEntryPayload.type,
                        isPrimaryAddressEmpty: false,
                    },
                    status: '',
                    type: $scope.updateEntryPayload.type,

                };

            } else {

                data = {
                    addresses: {
                        street1: $scope.updateEntryPayload.street1,
                        street2: $scope.updateEntryPayload.street2,
                        postalCode: $scope.updateEntryPayload.postalCode,
                        city: $scope.updateEntryPayload.city,
                        id: $scope.updateEntryPayload.id,
                        countryCode: 'DE',
                    },
                };

            }

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data,
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Addresses',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                }

            });

        };

    }

}

_serviceDependencies.push(DwmAddresses);

angular.module('controllers')
    .controller('DwmAddresses', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/addresses/addresses.js